import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 56px 20px 28px;

  @media (max-width: 768px) {
    padding: 42px 16px 20px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
`;

export const SectionEyebrow = styled.div`
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.primary};
  text-align: center;
`;

export const Title = styled.h2`
  font-size: 46px;
  font-weight: 800;
  color: ${({ theme }) => theme.text_primary};
  text-align: center;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 34px;
  }
`;

export const Desc = styled.p`
  font-size: 18px;
  line-height: 1.75;
  max-width: 820px;
  text-align: center;
  color: ${({ theme }) => theme.text_secondary};
  margin: 0 0 8px 0;

  @media (max-width: 768px) {
    font-size: 16px;
    max-width: 95%;
  }
`;

export const Card = styled.div`
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(20, 33, 61, 0.98) 0%,
    rgba(16, 28, 53, 0.99) 100%
  );
  border: 1px solid rgba(253, 181, 21, 0.14);
  box-shadow:
    0 12px 40px rgba(0, 0, 0, 0.22),
    inset 0 1px 0 rgba(255, 255, 255, 0.03);
  border-radius: 28px;
  padding: 34px;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -120px;
    right: -120px;
    width: 260px;
    height: 260px;
    background: radial-gradient(
      circle,
      rgba(253, 181, 21, 0.1) 0%,
      rgba(253, 181, 21, 0) 70%
    );
    pointer-events: none;
  }

  @media (max-width: 768px) {
    padding: 22px;
    border-radius: 22px;
  }
`;

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  color: ${({ theme }) => theme.primary};
  background: rgba(253, 181, 21, 0.08);
  border: 1px solid rgba(253, 181, 21, 0.18);
  margin-bottom: 18px;
`;

export const ProjectTitle = styled.h3`
  font-size: 31px;
  font-weight: 800;
  color: ${({ theme }) => theme.text_primary};
  margin: 0 0 14px 0;
  line-height: 1.2;
  max-width: 920px;

  @media (max-width: 768px) {
    font-size: 25px;
  }
`;

export const ProjectDesc = styled.p`
  font-size: 18px;
  line-height: 1.85;
  color: ${({ theme }) => theme.text_secondary};
  margin: 0 0 22px 0;
  max-width: 980px;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.75;
  }
`;

export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 28px;
`;

export const Chip = styled.div`
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme, $accent }) =>
    $accent ? theme.primary : theme.text_primary};
  background: ${({ $accent }) =>
    $accent ? "rgba(253, 181, 21, 0.08)" : "rgba(255, 255, 255, 0.04)"};
  border: 1px solid
    ${({ $accent }) =>
      $accent ? "rgba(253, 181, 21, 0.18)" : "rgba(255, 255, 255, 0.08)"};
`;

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  margin-bottom: 28px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const HighlightsCard = styled.div`
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 18px;
  padding: 22px 22px 18px;
`;

export const HighlightsTitle = styled.h4`
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.text_primary};
  margin: 0 0 14px 0;
`;

export const HighlightList = styled.ul`
  margin: 0;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const HighlightItem = styled.li`
  color: ${({ theme }) => theme.text_secondary};
  line-height: 1.7;
  font-size: 17px;

  &::marker {
    color: ${({ theme }) => theme.primary};
  }

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

export const CTASection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Buttons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
`;

export const ActionButton = styled.a`
  text-decoration: none;
  padding: 14px 22px;
  border-radius: 16px;
  color: ${({ theme }) => theme.white};
  font-weight: 700;
  font-size: 16px;
  background: linear-gradient(225deg, #6a11ff 0%, #19c6ff 100%);
  box-shadow: 0 8px 24px rgba(25, 198, 255, 0.18);
  transition: transform 0.2s ease, opacity 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    opacity: 0.97;
    box-shadow: 0 12px 30px rgba(25, 198, 255, 0.22);
  }
`;

export const SecondaryButton = styled.a`
  text-decoration: none;
  padding: 14px 22px;
  border-radius: 16px;
  color: ${({ theme }) => theme.text_primary};
  font-weight: 700;
  font-size: 16px;
  border: 1px solid ${({ theme }) => theme.primary};
  background: transparent;
  transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    background: rgba(253, 181, 21, 0.08);
    border-color: rgba(253, 181, 21, 0.85);
  }
`;

export const SmallNote = styled.div`
  font-size: 14px;
  line-height: 1.65;
  color: ${({ theme }) => `${theme.text_secondary}C5`};
  max-width: 760px;
`;
